/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks, useSetting, __experimentalFontFamilyControl as FontFamilyControl } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { compose } from '@wordpress/compose';
import { withDispatch, select } from '@wordpress/data';

import Inspector from './inspector';
import BlockAppenderButton from '../../components/BlockAppenderButton';

const Edit = ( props ) => {
	const { blockClientId } = props.attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-block-faq-wrapper`,
		`gutenify-section-${ blockClientId }`,
	);
	const { isSelected, className } = props;
	// const blockLevelFontFamilies = useSetting( 'typography.fontFamilies' );
	return <div className={ wrapperClasses } >
		{ isSelected && <Inspector { ...props } /> }
		{ /* <FontFamilyControl
			fontFamilies={ blockLevelFontFamilies }
			value={ 'fontFamily' }
		/> */ }
		<InnerBlocks
			allowedBlocks={ [ 'gutenify/content-toggle-item' ] }
			renderAppender={ () => {
				return <BlockAppenderButton { ...props } label={ __( '+ Add Faq' ) } />;
			} }
		/>
	</div>;
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;
		const { selectBlock } = dispatch( 'core/block-editor' );

		return {
			updateInnerBlocks( initialOpenAll, initialOpenFirst ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child, index ) {
					if ( 'gutenify/content-toggle-item' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							initialOpen: 0 === index ? initialOpenFirst : initialOpenAll,
						} );
					}
				} );
			},
			selectBlock: () => {
				selectBlock( props.clientId );
			},
		};
	} ),
] )( Edit );

